import { normalizeFormChange } from "./validation";
import { useState } from "react";
import { StaticDropdown,StaticMultiSelectDropdown,TextInput,Button } from "src/Components";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { CoveredMatrixExecutionMethod,CoveredMatrixItemInput,CoveredMatrixVolumeCalculationType,CreateCoveredMatrixOrderRequest } from "src/Interfaces/coveredMatrixOrder";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GridViewIcon from "@mui/icons-material/GridView";
import PortfoGroupUserMultiSelectDropdown from "src/Components/Dropdown/Users/PortfoGroupUserMultiSelectDropdown";
import { volumeOptions,defaultCriterionType,criterionOptionsForExecutionMethod,criterionName,isFixedCallPriceCriterion,isMaximumCostCriterion,executionMethodOptions,sendOrderTypeOptions } from "./model";

export const AddForm=({ draft,setDraft,bases,options,onReset,onOptions,onCriteria,onSubmit,loading }: {
  draft: CreateCoveredMatrixOrderRequest;
  setDraft: (value: CreateCoveredMatrixOrderRequest) => void;
  bases: DropdownItem[];
  options: DropdownItem[];
  onReset: () => void;
  onOptions: (defaults: Pick<CoveredMatrixItemInput,"criterionType"|"criterionValue">) => void;
  onCriteria: () => void;
  onSubmit: () => void;
  loading: boolean;
}) => {
  const volumeInputLabel=volumeOptions.find((option) => Number(option.id)===draft.volumeCalculationType)?.name||"حجم";
  const [criterionMode,setCriterionMode]=useState<"same"|"different">("different");
  const [sameCriterion,setSameCriterion]=useState("");
  const [selectedCriterionType,setSelectedCriterionType]=useState<number>(draft.items[0]?.criterionType??defaultCriterionType);
  const criterionOptions=criterionOptionsForExecutionMethod(draft.executionMethod);
  const selectedCriterionLabel=criterionName(selectedCriterionType);
  const change=(name: string,value: unknown) => {
    const next=normalizeFormChange(draft,name,value);
    if(name==="baseIsin")
      next.items=[];
    if(name==="executionMethod") {
      if(Number(value)!==CoveredMatrixExecutionMethod.FutureBasePurchase)
        next.manualBaseReferencePrice=null;
      if(Number(value)===CoveredMatrixExecutionMethod.BothSides&&isFixedCallPriceCriterion(selectedCriterionType)) {
        setSelectedCriterionType(defaultCriterionType);
        next.items=next.items.map((item) => ({ ...item,criterionType: defaultCriterionType,criterionValue: null }));
        setSameCriterion("");
      }
    }
    setDraft(next);
  };
  const changeCriterionType=(_: string,value: string|number|null) => {
    const nextCriterionType=Number(value);
    setSelectedCriterionType(nextCriterionType);
    if(isMaximumCostCriterion(nextCriterionType))
      setCriterionMode("different");
    setSameCriterion("");
    setDraft({
      ...draft,
      items: draft.items.map((item) => ({ ...item,criterionType: nextCriterionType,criterionValue: null })),
    });
  };
  const changeOptions=(_: string,value: Array<string|number>) => setDraft({
    ...draft,
    items: value.map((optionIsin) => draft.items.find((item) => item.optionIsin===optionIsin.toString())||
      ({ optionIsin: optionIsin.toString(),criterionType: selectedCriterionType,criterionValue: criterionMode==="same"&&sameCriterion!==""? Number(sameCriterion):null } as CoveredMatrixItemInput)),
  });
  const changeSameCriterion=(_: string,value: string) => {
    setSameCriterion(value);
    setDraft({
      ...draft,
      items: draft.items.map((item) => ({
        ...item,
        criterionValue: value===""? null:Number(value),
        criterionType: selectedCriterionType,
      })),
    });
  };
  const changeCriterionMode=(mode: "same"|"different") => {
    setCriterionMode(mode);
    if(mode==="different")
      setSameCriterion("");
    else
      changeSameCriterion("sameCriterion",sameCriterion);
  };
  return <div className="rounded border border-gray-300 bg-white p-3 flex flex-col gap-3" dir="rtl">
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2">
        <PortfoGroupUserMultiSelectDropdown
          name="accountIds"
          label="اکانت"
          extraLabel
          value={draft.accountIds}
          onChange={change}
          withTagBox
        />
      </div>
      <StaticDropdown
        dropdown={{ name: "process",placeholder: "فرآیند",extraLabel: true,disabled: true }}
        options={[{ id: 1,name: "ورود" }]}
        value={1}
        onChange={() => { }}
      />
      <StaticDropdown
        dropdown={{ name: "pairType",placeholder: "نوع جفت",extraLabel: true,disabled: true }}
        options={[{ id: 1,name: "کاوردکال" }]}
        value={1}
        onChange={() => { }}
      />
      <StaticDropdown
        dropdown={{ name: "baseIsin",placeholder: "نماد پایه",extraLabel: true }}
        options={bases}
        value={draft.baseIsin}
        onChange={change}
      />
      <StaticDropdown
        dropdown={{ name: "executionMethod",placeholder: "روش اجرا",extraLabel: true }}
        options={executionMethodOptions}
        value={draft.executionMethod}
        onChange={change}
      />
      {draft.executionMethod===CoveredMatrixExecutionMethod.FutureBasePurchase? <div className="col-span-2">
        <TextInput
          extraLabel
          label="قیمت مبنای سمت اول"
          kind="price"
          name="manualBaseReferencePrice"
          value={draft.manualBaseReferencePrice?.toString()}
          onChange={change}
        />
      </div>:null}
      <div className="col-span-2 flex flex-col gap-1">
        <div className="text-[10px]">نماد سمت دوم</div>
        <div className="flex items-center gap-1">
          <div className="flex-1">
            <StaticMultiSelectDropdown
              name="optionIsins"
              label={`نماد سمت دوم (${draft.items.length})`}
              withSelectAll
              items={options}
              value={draft.items.map((item) => item.optionIsin)}
              onChange={changeOptions}
              disabled={!draft.baseIsin}
            />
          </div>
          <Button
            variant="outlined"
            text={<AccountTreeIcon fontSize="small" />}
            disabled={!draft.baseIsin}
            onClick={() => onOptions({ criterionType: selectedCriterionType,criterionValue: criterionMode==="same"&&sameCriterion!==""? Number(sameCriterion):null })}
            className="!h-8 !w-9 !min-w-9"
          />
        </div>
      </div>
      <StaticDropdown
        dropdown={{ name: "volumeCalculationType",placeholder: "روش تعیین حجم",extraLabel: true }}
        options={volumeOptions}
        value={draft.volumeCalculationType}
        onChange={change}
      />
      <TextInput
        extraLabel
        label={volumeInputLabel}
        kind={draft.volumeCalculationType===CoveredMatrixVolumeCalculationType.FixedAmount? "number":"percent"}
        name="volumeInput"
        value={draft.volumeInput?.toString()}
        onChange={change}
      />
      <div className="col-span-2">
        <StaticDropdown
          dropdown={{ name: "criterionType",placeholder: "نوع معیار",extraLabel: true }}
          options={criterionOptions}
          value={selectedCriterionType}
          onChange={changeCriterionType}
        />
      </div>
      <div className="col-span-2 grid grid-cols-[82px_94px_1fr] items-end gap-2 text-xs">
        <Button
          variant={criterionMode==="same"? "contained":"outlined"}
          text="یکسان"
          onClick={() => changeCriterionMode("same")}
          className="!h-9"
        />
        <Button
          variant={criterionMode==="different"? "contained":"outlined"}
          text={<span className="flex items-center gap-1"><GridViewIcon className="!text-base" />متفاوت</span>}
          onClick={() => changeCriterionMode("different")}
          className="!h-9"
        />
        {criterionMode==="same"? <TextInput
          extraLabel
          label={selectedCriterionLabel}
          kind="negativeDecimalNumbers"
          name="sameCriterion"
          value={sameCriterion}
          onChange={changeSameCriterion}
        />:<Button
          variant="outlined"
          text="تنظیم معیارها"
          onClick={onCriteria}
          disabled={!draft.items.length}
          className="!h-9"
        />}
      </div>
      <div className="col-span-2">
        <StaticDropdown
          dropdown={{ name: "sendOrderType",placeholder: "ترتیب ارسال",extraLabel: true }}
          options={sendOrderTypeOptions}
          value={draft.sendOrderType}
          onChange={change}
        />
      </div>
    </div>
    <div className="flex justify-between pt-3">
      <Button
        variant="outlined"
        text="پاک‌کردن"
        onClick={() => { setCriterionMode("different"); setSelectedCriterionType(defaultCriterionType); setSameCriterion(""); onReset(); }}
        className="!w-24"
      />
      <Button
        variant="contained"
        text="ارسال"
        onClick={onSubmit}
        loading={loading}
        disabled={loading||!draft.items.length}
        className="!w-24"
      />
    </div>
  </div>;
};
